import { sum, times } from 'lodash'
import create from 'zustand'

export const FIRST_COLUMN_DEFAULT_WIDTH = 428
export const COLUMN_MIN_WIDTH = 100 + 86 + 20 + 28 // (100=Name, 86=ActionButtons+MarginLeft, 20=Expand, 28=Icon)
export const COLUMN_MAX_WIDTH = 1000 + 86 + 20 + 28
export const NEW_COLUMN_WIDTH = 30

const CHECKBOX_WIDTH = 0
const MARGIN_WIDTH = 28

export type Store = {
  columnWidths: number[]
  firstColWidth: number
  restColsWidth: number
  allColsWidth: number
  fullTableWidth: number
  initializeColumnWidths: (numberOfCols: number) => void
  setColumnWidths: (columnWidths: number[]) => void
  setColumnWidth: (colIdx: number, colWidth?: number) => void
  getColumnWidth: (colIdx: number) => number
}

const blazeStore = create<Store>((set, get) => ({
  columnWidths: [],
  firstColWidth: FIRST_COLUMN_DEFAULT_WIDTH,
  restColsWidth: COLUMN_MIN_WIDTH,
  allColsWidth: FIRST_COLUMN_DEFAULT_WIDTH,
  fullTableWidth: FIRST_COLUMN_DEFAULT_WIDTH,
  initializeColumnWidths: (numberOfCols: number) =>
    get().setColumnWidths([FIRST_COLUMN_DEFAULT_WIDTH, ...times(numberOfCols, () => COLUMN_MIN_WIDTH)]),
  setColumnWidths: (columnWidths: number[]) =>
    set({
      columnWidths,
      firstColWidth: columnWidths[0],
      restColsWidth: sum(columnWidths.slice(1)),
      allColsWidth: sum([...columnWidths, CHECKBOX_WIDTH]),
      fullTableWidth: sum([...columnWidths, CHECKBOX_WIDTH, MARGIN_WIDTH]),
    }),
  setColumnWidth: (colIdx: number, colWidth?: number) => {
    const { columnWidths, setColumnWidths } = get()
    if (!columnWidths.length) return
    columnWidths[colIdx] = colWidth || (colIdx === 0 ? FIRST_COLUMN_DEFAULT_WIDTH : COLUMN_MIN_WIDTH)
    return setColumnWidths(columnWidths)
  },
  getColumnWidth: (colIdx: number) => get().columnWidths[colIdx],
}))

const useColumnWidthsStore = () => {
  return blazeStore()
}

export { useColumnWidthsStore }
